import Vue from 'vue'
import VueRouter, { RouteConfig, Route } from 'vue-router'
import CreatePlatformPage from '@/views/CreatePlatformPage.vue'
import PersonalInfoPage from '@/views/PersonalInfoPage.vue'
import TermsAndConditionsPage from '@/views/TermsAndConditionsPage.vue'
import ProgressPage from '@/views/ProgressPage.vue'

Vue.use(VueRouter)

export enum Routes {
    START = 'START',
    PERSONAL_INFO = 'PERSONAL_INFO',
    PLATFORM_SETTINGS = 'PLATFORM_SETTINGS',
    TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
    PROGRESS = 'PROGRESS',
}

function redirectDirectToPerson(to: Route, from: Route, next: any) {
    if (from.name === null) next('/person')
    else next()
}

const routes: Array<RouteConfig> = [
    {
        path: '/',
        redirect: '/person',
    },
    {
        path: '/person',
        name: Routes.PERSONAL_INFO,
        component: PersonalInfoPage,
    },
    {
        path: '/platform',
        name: Routes.PLATFORM_SETTINGS,
        component: CreatePlatformPage,
        beforeEnter: redirectDirectToPerson,
    },
    {
        path: '/terms-and-conditions',
        name: Routes.TERMS_AND_CONDITIONS,
        component: TermsAndConditionsPage,
        beforeEnter: redirectDirectToPerson,
    },
    {
        path: '/progress',
        name: Routes.PROGRESS,
        component: ProgressPage,
        beforeEnter: redirectDirectToPerson,
    },
    {
        path: '*',
        redirect: '/person',
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

function hasQueryParams(route) {
    return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {
    if(!hasQueryParams(to) && hasQueryParams(from)){
     next({name: to.name || '', query: from.query});
   } else {
     next()
   }
 })

export default router
